import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErpArticleModule } from './erp-articles/erp-article.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ErpArticleModule
  ]
})
export class ErpProductModule { }
